import React, { useEffect, useState } from 'react'
import { Row, Col, Uploader, Icon, Message } from 'rsuite'
import {
  requiredFiled,
  isValidators,
  isImageOrPdf,
  isValidFileType,
} from '../../../utils/ValidatorUtils'
import CustomIconMessageInfo from '../../../widgets/CustomIconMessageInfo'
import ErrorMessage from '../../message/errorMessage/ErrorMessage'
import { isEmpty } from 'lodash-es'

export default function UploaderForm({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  index,
  single,
  listType = 'picture-text',
  fileListVisible = true,
  ignoreValidate,
  onChange = () => {},
  hideIcon,
  ...props
}) {
  const keyName = props?.name || schema?.name
  const labelMdLg = props.labelMdLg || 24
  const inputMdlg = props.inputMdlg || 24
  const disabled = props.disabled || schema.disabled || false
  //const values = props.value || []
  const defaultMaxFileSize = 5
  const defaultSupportType = '.jpg, .jpeg, .png, .pdf'

  const [fileErr, setFileErr] = useState('')
  const [values, setValues] = useState(props.value || [])

  return (
    <>
      {schema && (
        <Row style={{ ...props.style }}>
          {errors[keyName] && (
            <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
              <ErrorMessage error={errors[keyName]} />
            </Col>
          )}
          {fileErr && (
            <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10, marginBottom: 10 }}>
              <Message
                closable
                onClose={() => {
                  setFileErr('')
                }}
                showIcon
                type="error"
                description={fileErr}
              />
            </Col>
          )}

          {!props.hideLabel && schema.label && (
            <Col xs={24} sm={24} md={labelMdLg} lg={labelMdLg} style={{ marginTop: 10 }}>
              {ignoreValidate ? (
                <>
                  <p>{`${schema.label} ${index || ''}`}</p>
                </>
              ) : (
                <p>{requiredFiled(schema.validators, `${schema.label} ${index || ''}`)}</p>
              )}
            </Col>
          )}
          {schema.description && (
            <Col xs={24} sm={24} md={labelMdLg} lg={labelMdLg} style={{ marginTop: 10 }}>
              <CustomIconMessageInfo style={{ marginBottom: 10 }} contents={schema.description} />
            </Col>
          )}
          <Col xs={24} sm={24} md={inputMdlg} lg={inputMdlg} style={{ marginTop: 5 }}>
            <Controller
              key={keyName}
              name={keyName}
              control={control}
              rules={ignoreValidate ? {} : isValidators(schema.validators)}
              defaultValue={undefined}
              value={values}
              render={(props) => {
                return (
                  <Uploader
                    autoUpload={false}
                    disabled={disabled}
                    fileListVisible={fileListVisible}
                    draggable
                    listType={listType}
                    fileList={props.value || values || []}
                    accept={schema.fileType || defaultSupportType}
                    onChange={(fileList) => {
                      if (isEmpty(fileList)) {
                        props.onChange(undefined)
                        setValues([])
                        onChange([])
                        setFileErr('')
                      } else {
                        let file = fileList[fileList.length - 1]

                        if (
                          file.blobFile.size >
                          (schema.fileSize || defaultMaxFileSize) * 1024 * 1024
                        ) {
                          setFileErr(`ขนาดไฟล์เกิน ${schema.fileSize || defaultMaxFileSize} MB`)

                          return
                        }

                        if (
                          isValidFileType(file.blobFile.type, schema.fileType || defaultSupportType)
                        ) {
                          if (single) {
                            props.onChange([file])
                            setValues([file])
                            onChange([file])
                          } else {
                            props.onChange(fileList)
                            setValues(fileList)
                            onChange(fileList)
                          }

                          setFileErr('')
                        } else {
                          setFileErr('ชนิดไฟล์ที่รองรับ ' + (schema.fileType || defaultSupportType))
                        }
                      }
                    }}
                  >
                    <div style={{ lineHeight: '80px' }}>
                      {!hideIcon ? (
                        <>
                          <Icon size="4x" icon="upload2" />

                          <small
                            style={{
                              marginTop: '-50px',
                              display: 'block',
                              whiteSpace: 'nowrap',
                              textOverflow: 'ellipsis',
                            }}
                          >
                            {`คลิกหรือลากไฟล์มายังพื้นที่นี้ ชนิดไฟล์ที่รองรับ : ${
                              schema.fileType || '.jpg, .jpeg, .png, .pdf'
                            } , ขนาดไฟล์ไม่เกิน ${schema.fileSize || defaultMaxFileSize} MB`}
                          </small>
                        </>
                      ) : (
                        <Icon size="2x" icon="upload2" />
                      )}
                    </div>
                  </Uploader>
                )
              }}
            />
          </Col>
        </Row>
      )}
    </>
  )
}
